"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _utils = require("composer-lib/lib/utils");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

// Provides a wrapper component that renders the given element type
// with given props and passes through the handleKeyCommand function thru to its children.
// Use KeyCommandAccessible directly from your configured Composer component to get that function.
// This is basically useful if the component that needs access to key command handler needs to be nested.
var _default = (0, _createReactClass.default)({
  displayName: "KeyCommandAccessible",
  mixins: [_reactAddonsPureRenderMixin.default],
  propTypes: {
    addKeyCommandListener: _propTypes.default.func,
    children: _propTypes.default.node.isRequired,
    elementType: _propTypes.default.string,
    handleKeyCommand: _propTypes.default.func,
    removeKeyCommandListener: _propTypes.default.func
  },
  render: function render() {
    var _this$props = this.props,
        addKeyCommandListener = _this$props.addKeyCommandListener,
        children = _this$props.children,
        elementType = _this$props.elementType,
        handleKeyCommand = _this$props.handleKeyCommand,
        removeKeyCommandListener = _this$props.removeKeyCommandListener,
        other = (0, _objectWithoutProperties2.default)(_this$props, ["addKeyCommandListener", "children", "elementType", "handleKeyCommand", "removeKeyCommandListener"]);
    var Element = elementType || 'div';
    return _react.default.createElement(Element, other, _react.default.Children.map(children, function (child) {
      if (child && (0, _utils.isReactComponent)(child)) {
        return _react.default.cloneElement(child, {
          addKeyCommandListener: addKeyCommandListener,
          handleKeyCommand: handleKeyCommand,
          removeKeyCommandListener: removeKeyCommandListener
        });
      }

      return child;
    }));
  }
});

exports.default = _default;
module.exports = exports.default;